export function scoreTone(score) {
  if (score == null) return 'muted';
  if (score >= 80) return 'green';
  if (score >= 60) return 'sky';
  if (score >= 40) return 'amber';
  return 'red';
}

export function scoreBadgeClasses(tone, modoOscuro) {
  if (tone === 'green') return modoOscuro ? 'bg-green-900/40 text-green-200' : 'bg-green-50 text-green-800';
  if (tone === 'sky') return modoOscuro ? 'bg-sky-900/40 text-sky-200' : 'bg-sky-50 text-sky-800';
  if (tone === 'amber') return modoOscuro ? 'bg-amber-900/40 text-amber-200' : 'bg-amber-50 text-amber-800';
  if (tone === 'red') return modoOscuro ? 'bg-red-900/40 text-red-200' : 'bg-red-50 text-red-800';
  return modoOscuro ? 'bg-gray-800 text-gray-400' : 'bg-gray-100 text-gray-600';
}
